<template slot-scope="scope">
  <div>
    <ods-form :model="datosUsuarios" :rules="ticketRules" ref="datosUsuarios" :inline='true'>
      <div class="default-form">
        <ods-dialog
            :visible.sync="isVisible"
            @open="openModify"
            :before-close="handleClose"
            width="50%"
            :append-to-body="true">
                <ods-row class="grid-content bg-purple detalle-usarioa-al">
                  <ods-col :span="18">
                    <span>DETALLE USUARIO - {{ datosUsuarios.nombre + ' ' + datosUsuarios.apelli1}}</span>
                  </ods-col>
                  <ods-col v-if="rowModify.editable" class="text-button" :span="6" :offset="0">
                    <span v-if="validatorbtnEdit" @click="habEditar()">EDITAR</span>
                  </ods-col>
                </ods-row>
            <ods-row :gutter="10" style="margin-top: 3%;">
              <ods-col :span="8">
                <ods-form-item
                    prop="usuario">
                  <ods-input
                    :disabled="deshabilitaUsuario"
                    v-model="datosUsuarios.usuario"
                    label="usuario"
                    :maxlength="22"
                    size="hecto">
                  </ods-input>
                  </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item
                  label="código perfil" prop="codperfil">
                    <ods-select v-model="datosUsuarios.codperfil" size="hecto" @change="changePerfil" :disabled="deshabilitaPerfil">
                      <ods-option
                        v-for="item in this.listProfile"
                        :key="item.valor"
                        :value="item.valor + ' - '+ item.descrip">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="perfil navegación"  prop="codperfpo">

                  <ods-select v-model="datosUsuarios.codperfpo" size="hecto" :disabled="adminFpo">
                      <ods-option
                        v-for="item in this.navProfile"
                        :key="item.registro_Numero"
                        :value="item.codperfpo + ' - '+ item.desperfpo">
                      </ods-option>
                  </ods-select>

                </ods-form-item>
              </ods-col>
            </ods-row>
            <ods-row :gutter="10" style="margin-top: 2%;">
              <ods-col :span="8">
                <ods-form-item label="holding" prop="holding">
                    <ods-select v-model="datosUsuarios.holding" size="hecto" @change="changeHolding" :disabled="deshabilitaHolding">
                      <ods-option
                        v-for="item in this.lHolding"
                        :key="item.holding"
                        :value="item.holding + ' - ' + item.desholding">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="cadena" prop="codcadena">
                    <ods-select ref="refCadena" v-model="datosUsuarios.codcadena" size="hecto" @change="changeCadena" :disabled="deshabilitaCadena">
                      <ods-option
                        v-for="item in this.lCommerce"
                        :key="item.codcadenal"
                        :value="item.codcadenal + ' - ' + item.descadena">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="comercio" prop="codcom">
                    <ods-select ref="refCodcom" v-model="datosUsuarios.codcom" size="hecto" :disabled="deshabilitaComercio" @change="changeCodcom">
                      <ods-option
                        v-for="item in this.lCommercial"
                        :key="item.codcom"
                        :value="item.codcom + ' - ' + item.descomercio">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
            </ods-row>
            <ods-row :gutter="10" style="margin-top: 2%;">
              <ods-col :span="8">
                <ods-form-item label="nombre" prop="nombre">
                  <ods-input
                    :disabled="deshabilitaNombre"
                    v-model="datosUsuarios.nombre"
                    :maxlength="100"
                    size="hecto"
                    type="text">
                  </ods-input>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="primer apellido" prop="apelli1">
                  <ods-input
                    :disabled="deshabilitaApelli1"
                    v-model="datosUsuarios.apelli1"
                    :maxlength="30"
                    size="hecto"
                    type="text">
                  </ods-input>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item
                label="segundo apellido" prop="apelli2">
                  <ods-input
                    :disabled="deshabilitaApelli2"
                    v-model="datosUsuarios.apelli2"
                    :maxlength="30"
                    size="hecto"
                    type="text">
                  </ods-input>
                </ods-form-item>
              </ods-col>
            </ods-row>
            <ods-row :gutter="10" style="margin-top: 2%;">
              <ods-col :span="8">
                <ods-form-item label="email" prop="email">
                  <ods-input
                    type="email"
                    :disabled="deshabilitaEmail"
                    v-model="datosUsuarios.email"
                    :maxlength="50"
                    size="hecto"></ods-input>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="teléfono móvil" prop="tel_movil">
                  <ods-input
                    :disabled="deshabilitaTelMovil"
                    v-model="datosUsuarios.tel_movil"
                    size="hecto"
                    maxlength="20"
                    oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57">
                  </ods-input>
                </ods-form-item>
              </ods-col>
            </ods-row>
                <span slot="footer" class="dialog-footer">
                  <ods-button
                    v-if="rowModify.editable && validatorHoldin"
                    style="position: absolute; right: 7%; margin-top: -2%;"
                    size="medium" type="secondary;"
                    @click="onSubmit('datosUsuarios')">guardar</ods-button>
                </span>
        </ods-dialog>
      </div>
    </ods-form>
    <dialog-generic-error
        :message="errorMessage"
        :dialogError="dialogError"
        :before-close-fn="handleCloseSession"
        @dialogClosed="closeDialogError($event)">
      </dialog-generic-error>
      <dialog-generic-success
        :dialogSuccess="dialogSuccess"
        @dialogClosed="closeDialogSuccess($event)">
      </dialog-generic-success>
      <dialog-generic-warning
        :dialogError="dialogErrorImg"
        :message="warningMessage"
        :dialogWarning="dialogWarning"
        @dialogClosed="closeDialogWarning($event)">
      </dialog-generic-warning>
      </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogGenericError from '@/components/dialogs/DialogGenericError'
import DialogConfirmSuccess from '@/components/dialogs/DialogConfirmSuccess'
import DialogGenericWarning from '@/components/dialogs/DialogGenericWarning'
import { Utils } from '@/utils/Utils.js'

export default {
  props: ['isVisible', 'rowModify', 'filtradoComercio', 'codcomercio'],
  data () {
    var validateUsuario = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateNombre = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateApelli1 = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateTelf = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateEmail = (rule, value, callback) => {
      if (!Utils.validateEmail(value)) {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateCodperfil = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateHolding = (rule, value, callback) => {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const roleHolding = storageAppData.customer_role
      if (roleHolding === '02' || roleHolding === '03') {
        callback()
      } else if (value.trim() === '') {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    // var validateCadcadena = (rule, value, callback) => {
    //   const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
    //   const roleCadena = storageAppData.customer_role
    //   if (roleCadena === '03') {
    //     callback()
    //   } else if (value.trim() === '') {
    //     callback(new Error('Campo obligatorio'))
    //   } else {
    //     callback()
    //   }
    // }
    // var validateCodcom = (rule, value, callback) => {
    //   if (value.trim() === '') {
    //     callback(new Error('Campo obligatorio'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      dialogTableVisible: false,
      deshabilitaUsuario: true,
      deshabilitaPerfil: true,
      deshabilitaHolding: true,
      deshabilitaCadena: true,
      deshabilitaComercio: true,
      deshabilitaNombre: true,
      deshabilitaApelli1: true,
      deshabilitaApelli2: true,
      deshabilitaEmail: true,
      deshabilitaTelFijo: true,
      deshabilitaTelMovil: true,
      role: '',
      disabled: true,
      datosUsuarios: {
        apelli1: '',
        apelli2: '',
        codcadena: '',
        codcom: '',
        codperfil: '',
        email: '',
        holding: '',
        nombre: '',
        codperfpo: '',
        tel_movil: '',
        usuario: ''
      },
      validatorHoldin: false,
      validatorbtnEdit: true,
      datosUserHoldin: {
        codperfil: '',
        holding: '',
        nombre: '',
        apelli1: '',
        email: '',
        tel_movil: ''
      },
      datosUserCadena: {
        codperfil: '',
        holding: '',
        codcadena: '',
        nombre: '',
        apelli1: '',
        email: '',
        tel_movil: ''
      },
      datosUserComerc: {
        codperfil: '',
        holding: '',
        codcadena: '',
        codcom: '',
        nombre: '',
        apelli1: '',
        email: '',
        tel_movil: ''
      },
      ticketRules: {
        usuario: [
          { required: true, validator: validateUsuario, trigger: 'blur' }
        ],
        nombre: [
          { required: true, validator: validateNombre, trigger: 'blur' }
        ],
        apelli1: [
          { required: true, validator: validateApelli1, trigger: 'blur' }
        ],
        tel_movil: [
          { required: true, validator: validateTelf, trigger: 'blur' }
        ],
        email: [
          { required: true, validator: validateEmail, trigger: 'blur' }
        ],
        holding: [
          { required: false, validator: validateHolding, trigger: 'change' }
        ],
        codperfil: [
          { required: false, validator: validateCodperfil, trigger: 'change' }
        ]
        // codcadena: [
        //   { required: false, validator: validateCadcadena, trigger: 'change' }
        // ],
        // codcom: [
        //   { required: false, validator: validateCodcom, trigger: 'change' }
        // ]
      },
      dialogError: false,
      dialogSuccess: false,
      dialogWarning: false,
      dialogErrorImg: false,
      hasErrors: false,
      errorMessage: '',
      warningMessage: '',
      valido: '',
      disableSave: false,
      perfil: '',
      adminFpo: true,
      navProfile: []

    }
  },
  methods: {
    onSubmit (datosUsuarios) {
      this.validarFormulario(this.perfil)
      if (this.disableSave) {
        const codPerfilEnvio = this.datosUsuarios.codperfil.substring(0, 2)
        const holdingEnvio = this.datosUsuarios.holding.substring(0, 3)
        let codCadenaEnvio = this.datosUsuarios.codcadena ? this.datosUsuarios.codcadena.substring(0, 3) : this.datosUsuarios.codcadena = ''
        if (codCadenaEnvio === 'Sel') {
          codCadenaEnvio = 'Seleccionar'
        }
        const codComEnvio = this.datosUsuarios.codcom ? this.datosUsuarios.codcom.substring(0, 15) : this.datosUsuarios.codcom = ''
        this.datosUsuarios.codperfil = codPerfilEnvio
        this.datosUsuarios.holding = holdingEnvio
        this.datosUsuarios.codcadena = codCadenaEnvio
        this.datosUsuarios.codcom = codComEnvio
        this.datosUsuarios.codperfpo = this.datosUsuarios.codperfpo.substring(0, 2)

        this.$store.dispatch('modUser', this.datosUsuarios).then(r => {
          this.handleClose()
          this.refreshListUsers()
          if (r.error === true) {
            this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
          } else if (r.warning === true) {
            this.dialogErrorImg = true
            this.displayErrorWarning(r.data.runServiceResponse.return.descRetorno)
          } else {
            this.displayConfirmSuccess()
          }
        }).catch(e => {
          console.error('Error in list Users - App', e)
        })
      } else {

      }
      // this.$refs[this.datosUserHoldin].validate((valid) => {
      // })
    },

    validarFormulario (val) {
      switch (val) {
        case '01':
          if (this.datosUsuarios.holding && this.datosUsuarios.codcadena && this.datosUsuarios.nombre && this.datosUsuarios.apelli1 && this.datosUsuarios.email && this.datosUsuarios.tel_movil) {
            this.disableSave = true
          }
          break
        case '02':
          if (this.datosUsuarios.holding && this.datosUsuarios.codcadena && this.datosUsuarios.nombre && this.datosUsuarios.apelli1 && this.datosUsuarios.email && this.datosUsuarios.tel_movil) {
            this.disableSave = true
          }
          break
        case '03':
          if (this.datosUsuarios.holding && this.datosUsuarios.codcadena && this.datosUsuarios.codcom && this.datosUsuarios.nombre && this.datosUsuarios.apelli1 && this.datosUsuarios.email && this.datosUsuarios.tel_movil) {
            this.disableSave = true
          }
          break
      }
    },

    habEditar () {
      this.executeListNavProfile()
      this.rowModify.admin !== 1 ? this.adminFpo = true : this.adminFpo = false
      if (this.datosUsuarios.codperfil.substring(0, 2) === '01' || this.datosUsuarios.codperfil.substring(0, 2) === '99') {
        this.datosUsuarios.codcadena = 'Seleccionar'
        this.datosUsuarios.codcom = 'Seleccionar'
        this.deshabilitaPerfil = false
        this.deshabilitaHolding = false
        this.deshabilitaCadena = true
        this.deshabilitaComercio = true
        this.deshabilitaNombre = false
        this.deshabilitaApelli1 = false
        this.deshabilitaApelli2 = false
        this.deshabilitaEmail = false
        this.deshabilitaTelFijo = false
        this.deshabilitaTelMovil = false
        this.validatorHoldin = true
        this.validatorbtnEdit = false
      } else if (this.datosUsuarios.codperfil.substring(0, 2) === '02') {
        if (this.role === '02') {
          this.datosUsuarios.codcom = 'Seleccionar'
          this.deshabilitaPerfil = false
          this.deshabilitaHolding = true
          this.deshabilitaCadena = false
          this.deshabilitaComercio = true
          this.deshabilitaNombre = false
          this.deshabilitaApelli1 = false
          this.deshabilitaApelli2 = false
          this.deshabilitaEmail = false
          this.deshabilitaTelFijo = false
          this.deshabilitaTelMovil = false
          this.validatorHoldin = true
          this.validatorbtnEdit = false
        } else {
          this.datosUsuarios.codcom = 'Seleccionar'
          this.deshabilitaPerfil = false
          this.deshabilitaHolding = false
          this.deshabilitaCadena = false
          this.deshabilitaComercio = true
          this.deshabilitaNombre = false
          this.deshabilitaApelli1 = false
          this.deshabilitaApelli2 = false
          this.deshabilitaEmail = false
          this.deshabilitaTelFijo = false
          this.deshabilitaTelMovil = false
          this.validatorHoldin = true
          this.validatorbtnEdit = false
        }
      } else if (this.datosUsuarios.codperfil.substring(0, 2) === '03' || this.datosUsuarios.codperfil.substring(0, 2) === '04') {
        if (this.role === '02') {
          this.deshabilitaPerfil = false
          this.deshabilitaHolding = true
          this.deshabilitaCadena = false
          this.deshabilitaComercio = false
          this.deshabilitaNombre = false
          this.deshabilitaApelli1 = false
          this.deshabilitaApelli2 = false
          this.deshabilitaEmail = false
          this.deshabilitaTelFijo = false
          this.deshabilitaTelMovil = false
          this.validatorHoldin = true
          this.validatorbtnEdit = false
        } else if (this.role === '03' || this.role === '04') {
          this.deshabilitaPerfil = false
          this.deshabilitaHolding = true
          this.deshabilitaCadena = true
          this.deshabilitaComercio = false
          this.deshabilitaNombre = false
          this.deshabilitaApelli1 = false
          this.deshabilitaApelli2 = false
          this.deshabilitaEmail = false
          this.deshabilitaTelFijo = false
          this.deshabilitaTelMovil = false
          this.validatorHoldin = true
          this.validatorbtnEdit = false
        } else {
          this.deshabilitaPerfil = false
          this.deshabilitaHolding = false
          this.deshabilitaCadena = false
          this.deshabilitaComercio = false
          this.deshabilitaNombre = false
          this.deshabilitaApelli1 = false
          this.deshabilitaApelli2 = false
          this.deshabilitaEmail = false
          this.deshabilitaTelFijo = false
          this.deshabilitaTelMovil = false
          this.validatorHoldin = true
          this.validatorbtnEdit = false
        }
      }
    },

    executeListNavProfile () {
      this.$store.dispatch('listNavProfil')
        .then((res) => {
          this.navProfile = res
        })
    },

    executeSelectHolding (selectedRole) {
      this.$store.dispatch('listHolding').then(r => {
        this.datosUsuarios.codcadena = 'Seleccionar'
        this.datosUsuarios.codcom = 'Seleccionar'
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error en listProfile- App', e)
      })
    },
    executeSelectCadena (selectedRole, selectedHolding) {
      this.$store.dispatch('listCommerce', selectedHolding).then(r => {
        this.datosUsuarios.codcom = 'Seleccionar'
        if (selectedRole === '03' || selectedRole === '04') {
          this.executeSelectComercio(selectedRole, r.data.runServiceResponse.return.registros.codcadenal)
        }
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error en listHolding- App', e)
      })
    },
    executeSelectComercio (selectedRole, selectedCadena) {
      this.$store.dispatch('listCommercial', selectedCadena).then(r => {
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error in confirm token - App', e)
      })
    },
    changePerfil () {
      this.limpiarCampos(this.$data.datosUsuarios.codperfil)
      switch (this.$data.datosUsuarios.codperfil.substring(0, 2)) {
        case '01':
          this.deshabilitaHolding = false
          this.deshabilitaCadena = true
          this.deshabilitaComercio = true
          this.executeSelectHolding()
          break
        case '02':
          this.deshabilitaHolding = true
          this.deshabilitaCadena = false
          this.deshabilitaComercio = true
          if (this.role === '01' || this.role.toString() === '99') {
            this.deshabilitaHolding = false
            this.deshabilitaCadena = true
            this.deshabilitaComercio = true
            this.executeSelectHolding()
            // this.executeSelectHolding(this.$data.datosUsuarios.codperfil.substring(0, 2))
          } else {
            this.executeSelectCadena()
          }
          break
        case '03':
          this.deshabilitaHolding = true
          this.deshabilitaCadena = true
          this.deshabilitaComercio = false
          if (this.role === '01' || this.role.toString() === '99') {
            this.deshabilitaHolding = false
            this.deshabilitaCadena = true
            this.deshabilitaComercio = true
            this.executeSelectHolding()
            // this.executeSelectHolding(this.$data.datosUsuarios.codperfil.substring(0, 2))
          } else if (this.role === '02') {
            this.deshabilitaHolding = true
            this.deshabilitaCadena = false
            this.deshabilitaComercio = true
            this.executeSelectCadena()
            //  this.executeSelectCadena(this.$data.datosUsuarios.codperfil.substring(0, 2))
          } else {
            this.executeSelectComercio()
          }
          break
        case '04':
          this.deshabilitaHolding = true
          this.deshabilitaCadena = true
          this.deshabilitaComercio = false
          if (this.role === '01' || this.role.toString() === '99') {
            this.deshabilitaHolding = false
            this.deshabilitaCadena = true
            this.deshabilitaComercio = true
            this.executeSelectHolding()
            //  this.executeSelectHolding(this.$data.datosUsuarios.codperfil.substring(0, 2))
          } else if (this.role === '02') {
            this.deshabilitaHolding = true
            this.deshabilitaCadena = false
            this.deshabilitaComercio = true
            this.executeSelectCadena()
            //  this.executeSelectCadena(this.$data.datosUsuarios.codperfil.substring(0, 2))
          } else {
            this.executeSelectComercio()
          }
          break
        default:
          break
      }
    },
    changeHolding () {
      if (this.$data.datosUsuarios.codperfil.substring(0, 2) === '01' || this.$data.datosUsuarios.codperfil.substring(0, 2) === '99') {
      } else {
        this.$store.dispatch('listCommerce', this.$data.datosUsuarios.holding.substring(0, 3))
          .then(r => {
            this.datosUsuarios.codcadena = ''
            this.deshabilitaCadena = false
            this.$refs.refCadena.$el.classList.add('errorInput')
            if (r.error === true) {
              this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
            }
          })
          .catch(e => {
            console.error('Error en listHolding- App', e)
          })
      }
    },
    changeCadena () {
      if (this.$data.datosUsuarios.codperfil.substring(0, 2) === '02') {
        this.$refs.refCadena.$el.classList.replace('errorInput', 'no-error')
      } else {
        this.$store.dispatch('listCommercial', this.$data.datosUsuarios.codcadena.substring(0, 3)).then(r => {
          this.deshabilitaComercio = false
          this.datosUsuarios.codcom = ''
          this.$refs.refCadena.$el.classList.replace('errorInput', 'no-error')
          this.$refs.refCodcom.$el.classList.add('errorInput')
          if (r.error === true) {
            this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
          }
        }).catch(e => {
          console.error('Error in confirm token - App', e)
        })
      }
    },

    changeCodcom () {
      if (this.$data.datosUsuarios.codperfil.substring(0, 2) === '03') {
        this.$refs.refCodcom.$el.classList.replace('errorInput', 'no-error')
      }
    },

    limpiarCampos (codperfil) {
      this.datosUsuarios.holding = ''
      this.datosUsuarios.codcadena = ''
      this.datosUsuarios.codcom = ''
      this.datosUsuarios.codperfil = codperfil
    },
    handleClose () {
      this.adminFpo = true
      this.limpiarCampos('')
      this.validatorHoldin = false
      this.validatorbtnEdit = true
      this.disableSave = false
      this.dialogTableVisible = false
      this.deshabilitaHolding = true
      this.deshabilitaCadena = true
      this.deshabilitaComercio = true
      this.deshabilitaUsuario = true
      this.deshabilitaPerfil = true
      this.deshabilitaHolding = true
      this.deshabilitaCadena = true
      this.deshabilitaComercio = true
      this.deshabilitaNombre = true
      this.deshabilitaApelli1 = true
      this.deshabilitaApelli2 = true
      this.deshabilitaEmail = true
      this.deshabilitaTelFijo = true
      this.deshabilitaTelMovil = true
      this.$emit('closingDialog', this.dialogVisible)
    },
    openModify () {
      this.datosUsuarios.usuario = this.rowModify.usuario
      this.datosUsuarios.codperfil = this.rowModify.codperfil + '-' + this.rowModify.desperfil
      this.datosUsuarios.holding = this.rowModify.holding === '-' ? '001 - HOLDING ILUSTRADO1' : this.rowModify.holding + '-' + this.rowModify.desholding
      this.datosUsuarios.codcadena = this.rowModify.cadena_comercial + '-' + this.rowModify.descadena
      this.datosUsuarios.codcom = this.rowModify.comercio + '-' + this.rowModify.descomercio
      this.datosUsuarios.nombre = this.rowModify.nombre
      this.datosUsuarios.apelli1 = this.rowModify.apelli1
      this.datosUsuarios.apelli2 = this.rowModify.apelli2
      this.datosUsuarios.email = this.rowModify.email
      // this.datosUsuarios.tel_movil = this.rowModify.tel_movil
      this.datosUsuarios.codperfpo = this.rowModify.codperfpo + '-' + this.rowModify.desperfpo
      this.datosUsuarios.tel_movil = this.rowModify.tel_movil
    },

    refreshListUsers () {
      if (this.filtradoComercio === true) {
        this.$store.dispatch('listUsers', this.rowModify.comercio).then(r => {
          if (r.error === true) {
            this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
          }
        }).catch(e => {
          console.error('Error in list Users - App', e)
        })
      } else {
        this.$store.dispatch('listUsers', this.rowModify.comercio).then(r => {
          if (r.error === true) {
            this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
          }
        }).catch(e => {
          console.error('Error in list Users - App', e)
        })
      }
    },

    datosUsuariosMap () {
      this.datosUsuarios = Object.assign({}, this.rowModify)
    },

    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    closeDialogError (e) {
      this.dialogError = e
      this.handleCloseSession()
    },
    closeDialogSuccess (e) {
      this.dialogSuccess = e
    },
    closeDialogWarning (e) {
      this.dialogWarning = e
    },
    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogError = true
    },
    displayConfirmSuccess () {
      this.dialogSuccess = true
    },
    displayErrorWarning (msg) {
      this.warningMessage = `${msg}`
      this.dialogWarning = true
    }
  },

  watch: {
    validarPerfil (val) {
      this.perfil = val.substring(0, 2)
    }
  },

  computed: {
    validarPerfil () {
      return this.datosUsuarios.codperfil
    },

    ...mapGetters(
      {
        getProfile: 'getListProfileData',
        getHolding: 'getListHoldingData',
        getCommerce: 'getListCommerceData',
        getCommercial: 'getlistCommercialData'
      }
    ),

    listProfile () {
      let datosPerfil = []
      if (this.getProfile.registros !== undefined) {
        if (Array.isArray(this.getProfile.registros)) {
          datosPerfil = this.getProfile.registros
        } else {
          datosPerfil.push(this.getProfile.registros)
        }
      }
      return datosPerfil
    },

    lHolding () {
      let datosHolding = []
      if (this.$store.getters.getListHoldingData !== undefined) {
        if (this.$store.getters.getListHoldingData !== '') {
          datosHolding = this.$store.getters.getListHoldingData
        }
      }
      return datosHolding
    },
    lCommerce () {
      let datosComerce = []
      if (this.$store.getters.getListCommerceData !== undefined) {
        if (this.$store.getters.getListCommerceData !== '') {
          datosComerce = this.$store.getters.getListCommerceData
        }
      }
      return datosComerce
    },
    lCommercial () {
      let datosCommercial = []
      if (this.$store.getters.getlistCommercialData !== undefined) {
        if (this.$store.getters.getlistCommercialData !== '') {
          datosCommercial = this.$store.getters.getlistCommercialData
        }
      }
      return datosCommercial
    }
  },
  components: {
    DialogGenericError,
    'dialog-generic-success': DialogConfirmSuccess,
    'dialog-generic-warning': DialogGenericWarning
  },
  mounted () {
    const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
    this.role = storageAppData.customer_role
  }
}
</script>

<style lang="scss" scoped>
    .prue {
    text-align: right;
    font-size: 9px;
    color: #6E767D;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    letter-spacing: .5px;
    float: left;
    line-height: 16px;
    margin-bottom: 8px;
    font-weight: 500;
    }
/deep/  .ods-dialog__header {
    padding: 0px 0 16px;
    }
/deep/  .ods-dialog__footer {
    padding: 55px 0 4px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    }
/deep/  .ods-form-item__label {
    text-align: left;
    font-size: 9px;
    color: #6E767D;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    letter-spacing: .5px;
    float: unset;
    line-height: 16px;
    margin-bottom: 8px;
    }
  .detalle-usarioa-al {
    color: #060E14;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
  }
  .text-button {
    color: #2E6C99;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    cursor: pointer;
  }
/deep/  .errorInput{
    input {
      border-color: #de2f2f!important;
    }
  }
</style>
